import { render, staticRenderFns } from "./widgetBarchart.vue?vue&type=template&id=3b720bca&scoped=true"
import script from "./widgetBarchart.vue?vue&type=script&lang=js"
export * from "./widgetBarchart.vue?vue&type=script&lang=js"
import style0 from "./widgetBarchart.vue?vue&type=style&index=0&id=3b720bca&prod&scoped=true&lang=less"
import style1 from "./widgetBarchart.vue?vue&type=style&index=1&id=3b720bca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b720bca",
  null
  
)

export default component.exports